import { useWorkspaceId } from '../auth/WorkspaceState';

const pricingAllowedWorkspaceIds = new Set([
  'c6iYfapokglNCtx84OEu',
  '376c6749-8849-4202-b744-af26cce7832d',
  'a90f9c9d-bfe1-4288-9eaf-6aa9b9b8007a',
]);

export function isPricingAllowedWorkspace(workspaceId: string | undefined): boolean {
  return !!workspaceId && pricingAllowedWorkspaceIds.has(workspaceId);
}

export function useIsPricingAllowed(): boolean {
  const workspaceId = useWorkspaceId();
  return isPricingAllowedWorkspace(workspaceId);
}
